
































/* Created- 03 - Apr - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { PageContent, PageContentItem } from "../../Models/Components.model";
import { eParticaAction, ParticaEvent } from "../../Models/ParticaEvent";

@Component(
	{
		name: "ContentSelector"
	})
export default class ContentSelector extends Vue {
	@Prop() private content: PageContent; // your data
	@Prop() private width: number;

	private viewbox(): string {
		return `0 0 ${this.content.width} ${this.content.height}`;
	}

	private clicked(item: PageContentItem) {
		this.$emit("partica-event", { action: eParticaAction.LEFT_MOUSE_CLICK, item } as ParticaEvent);
	}
	private rightclicked(item: PageContentItem, e: any) {
		this.$emit("partica-event", { action: eParticaAction.RIGHT_MOUSE_CLICK, item, sourceEvent: e } as ParticaEvent);
	}
	private dragStart(item: PageContentItem, e: any) {
		e.dataTransfer.clearData();
		if (item.type === "text") {				
			e.dataTransfer.setData("text/plain", item.content);
			e.dataTransfer.setData("text/html", item.contentstyled);
		} else {
			e.dataTransfer.setData("text/html", `<p style='width:100%;text-align: center;'><img src='${this.getImage(item.content)}'/></p>`);
		}		
	}
	
	private getImage(url: string) {
		return url.replace(/.jpg/gi, ".600.jpg");
	}
}
